<div
  class="page-header"
  [ngStyle]="{
    'margin-left': navServices.collapseSidebar ? '40px' : '210px',
    width: navServices.collapseSidebar
      ? 'calc(100% - 25px)'
      : 'calc(100% - 205px)'
  }"
  [class.close_icon]="navServices.collapseSidebar"
>
  <div class="header-wrapper row m-0">
    <app-search></app-search>
    <div class="header-logo-wrapper col-auto p-0">
        <div class="logo-wrapper">
            <a routerLink="/">
                <img class="img-fluid for-light"
                     src="assets/images/logo/logo.png"
                     alt="" />
                <img class="img-fluid for-dark"
                     src="assets/images/logo/logo_dark.png"
                     alt="" />
            </a>
        </div>
         <button type="button"
                class="toggle-sidebar"
                id="left-arrow"
                (click)="sidebarToggle()"
                aria-label="Toggle Sidebar">
        </button>

        <div class="title_card">
            <div class="logo">
                <img class="img-fluid for-light logo_img"
                     src="assets/images/logo/deck-logo.svg"
                     alt="looginpage" />
                <span class="brand-project pt-2">Console </span>

                <sub> V{{ version }}</sub>
            </div>
        </div>
    </div>
    <div class="left-header col-xxl-5 col-xl-6 col-lg-5 col-md-4 col-sm-3 p-0">
      <app-swiper></app-swiper>
    </div>
    <div
      class="nav-right col-xxl-7 col-xl-6 col-md-7 col-8 pull-right right-header p-0 ms-auto"
    >
      <ul class="nav-menus">
          <button class="language-nav" (click)="languageToggle()" aria-label="Toggle language selection">
          </button>

        <li class="profile-nav onhover-dropdown p-0">
          <app-my-account></app-my-account>
        </li>
      </ul>
    </div>
  </div>
</div>
